import { get, reduce } from 'lodash';

const cleaningInitialValues = (state) => {
  const cleaningInfo = get(state, 'space.data.cleaning_info', '');

  const arrayToObj = (array) => (
    reduce(array, (result, value) => {
      const newResult = { ...result };
      newResult[value] = true;

      return newResult;
    }, {})
  );

  return {
    description: cleaningInfo.description,
    cleaning_measures: arrayToObj(cleaningInfo.cleaning_measures),
    protective_gear: arrayToObj(cleaningInfo.protective_gear),
    physical_distance: arrayToObj(cleaningInfo.physical_distance),
    signage: arrayToObj(cleaningInfo.signage)
  };
};

export default cleaningInitialValues;
